module.exports = __webpack_public_path__ + "f581d153d4523e1b35b1e37be6d02a78.png";